import React from 'react';

import { flameTheme, Flex } from '@lightspeed/flame/Core';
import { Text, TextLink } from '@lightspeed/flame/Text';

import { sanitizeText } from '../pages/utils/sanitize';

import { SerializedItem } from './types';

const SerializedRefundRow: React.FC<SerializedItem> = ({
  serial,
  colorName,
  sizeName,
  serializedId,
  isRefunded,
  isSelected,
}) => {
  const { fontSizes } = flameTheme;

  return (
    <Flex alignItems="center" flexWrap="wrap" mt={1} data-test="serialized-refund-row">
      <Flex>
        <Text>
          Serial:{' '}
          <TextLink
            data-test="serial-edit-link"
            style={{ wordBreak: 'break-all' }}
            onClick={() => {
              window.merchantos.register.navigateToView(
                'item.views.serialized',
                serializedId.toString()
              );
            }}
          >
            {serial ? <var className="notranslate">{sanitizeText(serial)}</var> : 'None'}
          </TextLink>
          {colorName || sizeName ? (
            <span style={{ marginRight: '6px', marginLeft: '6px' }}>&#8211;</span>
          ) : null}
        </Text>
      </Flex>
      <Flex fontSize={fontSizes.small} flexWrap="wrap">
        {colorName && (
          <Text>
            Color:{' '}
            <span className="notranslate" style={{ wordBreak: 'break-all' }}>
              {colorName}{' '}
              {colorName && sizeName ? <span style={{ marginRight: '6px' }}>,</span> : null}
            </span>
          </Text>
        )}
        {sizeName && (
          <Text>
            Size:{' '}
            <span className="notranslate" style={{ wordBreak: 'break-all' }}>
              {sizeName}
            </span>
          </Text>
        )}
        {isRefunded && <Text ml={1}>(Refunded)</Text>}
        {isSelected && <Text ml={1}>(Selected)</Text>}
      </Flex>
    </Flex>
  );
};

export default SerializedRefundRow;
